import React from "react";
import { NavLink,useLocation } from "react-router-dom";
import { useActiveMenu } from "../auth/ActiveMenuContext";
import NavBar from "./NavBar";
import Header from "../component/Header";
import { routes } from "../routes/routes";
import "./SideBar.css";
import Footer from "./Footer";
import SSTLogo from "../assets/images/sstlogo.png";

const SideBar = ({ children }) => {
  const { activeMenu, setActiveMenu } = useActiveMenu();
  const location = useLocation();  // Hook to get the current route

      // Check if the current route is '/VC'
      const isVisitingCardPage = location.pathname === "/VC";
      const isConnectPage = location.pathname === "/connect"
      const isAhsChatbotPage = location.pathname === "/AhsChatbot";
      const isInsurancePage = location.pathname === "/InsuranceBot";
      const isEcommerceBotPage = location.pathname === "/EcommerceBot";
      const isEcommerceBotEndpointPage = location.pathname === "/EcommerceBot/endpoint";
      const isEcommerceBotDatamodelPage = location.pathname === "/EcommerceBot/datamodel";
      const isEcommerceBotIntegrationPage = location.pathname === "/EcommerceBot/integration";
    
      // Don't render the Sidebar or Footer for '/VC' page
      if (isVisitingCardPage || isConnectPage) {
        return(
          <div>
            <div>
      <nav
        className="navbar navbar-expand-lg navbar-light bg-light"
        style={{
          backgroundColor: "#f5fbfe",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          padding:"0px",
          margin:"0px"
        }}
      >
        <a className="navbar-brand" href="/">
          <img
            src={SSTLogo}
            alt="SST Logo"
            style={{ width: "100px", height: "auto" ,margin:"0px" }}
          />
        </a>
      </nav>
    </div>
      <main>{children}</main>; // Just render the children (main content)
    </div>
        )}

      if(isAhsChatbotPage || isInsurancePage || isEcommerceBotPage || isEcommerceBotEndpointPage || isEcommerceBotDatamodelPage || isEcommerceBotIntegrationPage){
        return(
          <div>
             <main>{children}</main>;
          </div>
        ) 
      }

  return (
    <div className="containerside" style={{ margin: "0", padding: "0" }}>
      <section className="routes">
        {routes.map((route, index) => (
          <NavLink
            to={route.path}
            key={index}
            className={`link ${activeMenu === route.name ? "activeMenu" : ""}`}
            activeClassName="active"
            onClick={() => {
              setActiveMenu(route.name);
              localStorage.setItem("activeMenu", route.name);
            }}
          >
            <div className="icon">{route.icon}</div>
            <span className="name">{route.name}</span>
          </NavLink>
        ))}
      </section>
      <div className="content-area">
        <Header />
        <NavBar />
        <main>{children}</main>
        <Footer />
      </div>
    </div>
  );
};

export default SideBar;
